import { LoginRedirectState } from "@/shared/types";
import { defineStore } from "pinia";
import _ from "lodash";
import { getStoragePaths } from "@/shared/storeHelper";

export const initialState: LoginRedirectState = {
    routeObject: null
};

export const useLoginRedirectStore = defineStore("loginRedirect", {
    persist: {
        storage: localStorage,
        paths: getStoragePaths("loginRedirect"),
    },
    state: (): LoginRedirectState => (_.cloneDeep(initialState)),
    actions: {
        setRedirectRouteObject (routeObject: any): void {
            this.routeObject = routeObject;
        }
    }
});
